import {Chip, Colors, IconBulkOperations} from "../../../ui";

interface Props {
  count: number;
}

const BundleChip = ({count}: Props) => {
  return (
    <Chip
      icon={<IconBulkOperations size={16} color={Colors.primary._800} />}
      label={`${count} balances`}
      variant_={"neon"}
      size_={"small"}
    />
  );
};

export default BundleChip;
